import { SIZES } from 'common/constants/sizes';
import { WhiteSection } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledInvestmentCarving = styled.div`
  height: 100%;
  font-size: ${SIZES.medium};
  & ${WhiteSection} {
    padding: 2rem;
  }
`;
